var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"margin":"0 auto","text-align":"left"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }